import { useRef } from "react";
import './Home.css';
import Faq from "react-faq-component";

const Home = () => {
  
  const videoRef = useRef();
  const setPlayBack = () => {
    videoRef.current.playbackRate = 0.5;
  };


  return (
    <div>
<nav className="navbarhome">
    <div className="col-4 nbarlefttxt">
      <span className=""></span>
    </div>
          <div className="col-4">
            <img className="mainlogo" id="logo" src="BABDlogo.png"alt="Logo" width="952" height="280"/>
          </div>
    <div className="col-4 connecticonsplaceHome">
    <a href="https://etherscan.io/address/0xbA984C5D209F4b337ead2DA2fa7be946C20dd065" className="connecticons">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 293.775 293.667">
  <g id="etherscan-logo-light-circle" transform="translate(-219.378 -213.333)">
    <path id="Path_1" data-name="Path 1" d="M280.433,353.152A12.45,12.45,0,0,1,292.941,340.7l20.737.068a12.467,12.467,0,0,1,12.467,12.467v78.414c2.336-.692,5.332-1.43,8.614-2.2a10.389,10.389,0,0,0,8.009-10.11V322.073a12.469,12.469,0,0,1,12.467-12.47h20.779a12.47,12.47,0,0,1,12.467,12.47v90.276s5.2-2.106,10.269-4.245a10.408,10.408,0,0,0,6.353-9.577V290.9a12.466,12.466,0,0,1,12.465-12.467h20.779A12.468,12.468,0,0,1,450.815,290.9v88.625c18.014-13.055,36.271-28.758,50.759-47.639a20.926,20.926,0,0,0,3.185-19.537,146.6,146.6,0,0,0-136.644-99.006c-81.439-1.094-148.744,65.385-148.736,146.834a146.371,146.371,0,0,0,19.5,73.45,18.56,18.56,0,0,0,17.707,9.173c3.931-.346,8.825-.835,14.643-1.518a10.383,10.383,0,0,0,9.209-10.306V353.152" transform="translate(0 0)" fill="#fff"/>
    <path id="Path_2" data-name="Path 2" d="M244.417,398.641A146.808,146.808,0,0,0,477.589,279.9c0-3.381-.157-6.724-.383-10.049-53.642,80-152.686,117.405-232.79,128.793" transform="translate(35.564 80.269)" fill="#bfcfda"/>
  </g>
</svg>
        </a>
    <a href="https://opensea.io/collection/boredapebelowdeck" className="connecticons">
        <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><title>OpenSea</title><path d="M12 0C5.374 0 0 5.374 0 12s5.374 12 12 12 12-5.374 12-12S18.629 0 12 0ZM5.92 12.403l.051-.081 3.123-4.884a.107.107 0 0 1 .187.014c.52 1.169.972 2.623.76 3.528-.088.372-.335.876-.614 1.342a2.405 2.405 0 0 1-.117.199.106.106 0 0 1-.09.045H6.013a.106.106 0 0 1-.091-.163zm13.914 1.68a.109.109 0 0 1-.065.101c-.243.103-1.07.485-1.414.962-.878 1.222-1.548 2.97-3.048 2.97H9.053a4.019 4.019 0 0 1-4.013-4.028v-.072c0-.058.048-.106.108-.106h3.485c.07 0 .12.063.115.132-.026.226.017.459.125.67.206.42.636.682 1.099.682h1.726v-1.347H9.99a.11.11 0 0 1-.089-.173l.063-.09c.16-.231.391-.586.621-.992.156-.274.308-.566.43-.86.024-.052.043-.107.065-.16.033-.094.067-.182.091-.269a4.57 4.57 0 0 0 .065-.223c.057-.25.081-.514.081-.787 0-.108-.004-.221-.014-.327-.005-.117-.02-.235-.034-.352a3.415 3.415 0 0 0-.048-.312 6.494 6.494 0 0 0-.098-.468l-.014-.06c-.03-.108-.056-.21-.09-.317a11.824 11.824 0 0 0-.328-.972 5.212 5.212 0 0 0-.142-.355c-.072-.178-.146-.339-.213-.49a3.564 3.564 0 0 1-.094-.197 4.658 4.658 0 0 0-.103-.213c-.024-.053-.053-.104-.072-.152l-.211-.388c-.029-.053.019-.118.077-.101l1.32.357h.01l.173.05.192.054.07.019v-.783c0-.379.302-.686.679-.686a.66.66 0 0 1 .477.202.69.69 0 0 1 .2.484V6.65l.141.039c.01.005.022.01.031.017.034.024.084.062.147.11.05.038.103.086.165.137a10.351 10.351 0 0 1 .574.504c.214.199.454.432.684.691.065.074.127.146.192.226.062.079.132.156.19.232.079.104.16.212.235.324.033.053.074.108.105.161.096.142.178.288.257.435.034.067.067.141.096.213.089.197.159.396.202.598a.65.65 0 0 1 .029.132v.01c.014.057.019.12.024.184a2.057 2.057 0 0 1-.106.874c-.031.084-.06.17-.098.254-.075.17-.161.343-.264.502-.034.06-.075.122-.113.182-.043.063-.089.123-.127.18a3.89 3.89 0 0 1-.173.221c-.053.072-.106.144-.166.209-.081.098-.16.19-.245.278-.048.058-.1.118-.156.17-.052.06-.108.113-.156.161-.084.084-.15.147-.208.202l-.137.122a.102.102 0 0 1-.072.03h-1.051v1.346h1.322c.295 0 .576-.104.804-.298.077-.067.415-.36.816-.802a.094.094 0 0 1 .05-.03l3.65-1.057a.108.108 0 0 1 .138.103z" fill='white'/></svg>
        </a>
        <a href="https://twitter.com/BoredApeBD" className="connecticons">
        <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><title>Twitter</title><path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" fill='white'/></svg>
        </a>
    </div>
    
  </nav>
 
                
                 



<div className="TopGallery">
<div className="OSImage">
  <a target="_blank" href="https://opensea.io/assets/0xbc4ca0eda7647a8ab7c2061c2e118a18a936f13d/0?ref=">
  <img id="topApe" src="https://lh3.googleusercontent.com/mPpOei8345NWTVxmzN5wv_jU4xWsG_KZWBH28pFMuKdLQz-hq5AzeKMC3zA9-dMwZdKiZ6tvvpC4uzZzgYScpi6jEWTen3VUgrmjgw=s0" alt="topApe" width="631" height="631"/>
        </a>
        <div className="OSImageOverlay"><a href="https://opensea.io/assets/0xbc4ca0eda7647a8ab7c2061c2e118a18a936f13d/0?ref=" title="Buy on OpenSea" target="_blank"><img src="https://storage.googleapis.com/opensea-static/Logomark/Badge%20-%20Available%20On%20-%20BW.png" alt="Available on OpenSea"/></a>
</div></div>
        <div className="OSImage">
        <a target="_blank" href="https://opensea.io/assets/0xbc4ca0eda7647a8ab7c2061c2e118a18a936f13d/1?ref=">
  <img id="topApe" src="https://lh3.googleusercontent.com/9WkSu8CP7gZjaEmUy8cpaKG3mK6ScHeEDvQf8driDoRxuxy4GPAs_W_Dn_DQascQSGDkdUL4cjmsnRrL6xN-NDp-s_RNwN5pxiCo=s0" alt="topApe" width="631" height="631"/>
        </a><div className="OSImageOverlay"><a href="https://opensea.io/assets/0xbc4ca0eda7647a8ab7c2061c2e118a18a936f13d/1?ref=" title="Buy on OpenSea" target="_blank"><img src="https://storage.googleapis.com/opensea-static/Logomark/Badge%20-%20Available%20On%20-%20BW.png" alt="Available on OpenSea"/></a>
        </div></div>
        <div className="OSImage">
        <a target="_blank" href="https://opensea.io/assets/0xbc4ca0eda7647a8ab7c2061c2e118a18a936f13d/2?ref=">
  <img id="topApe" src="https://lh3.googleusercontent.com/m1aEl7dGOjJ5A8QAnpcc-K1rRRiNyG3IaLugPY8QVX7vVOkBOM6QMNrbUzFuLmp8N2U4rxcr5uj7W2le-C5Jzz2Ttq5CfELktYCtYw=s0" alt="topApe" width="631" height="631"/>
        </a>
        <div className="OSImageOverlay"><a href="https://opensea.io/assets/0xbc4ca0eda7647a8ab7c2061c2e118a18a936f13d/2?ref=" title="Buy on OpenSea" target="_blank"><img src="https://storage.googleapis.com/opensea-static/Logomark/Badge%20-%20Available%20On%20-%20BW.png" alt="Available on OpenSea"/></a>
        </div></div>
        <div className="OSImage">
        <a target="_blank" href="https://opensea.io/assets/0xbc4ca0eda7647a8ab7c2061c2e118a18a936f13d/3?ref=">
  <img id="topApe" src="https://lh3.googleusercontent.com/l3FDHfAh66oG2xgzf2lCOjXvlFlrYfQfZJupUCRDNe3b55DXSzGWBljcbFBnGCt2VjO4NidJSTim-sbrKOeoAr1vT6ymf-BOMSHiA1k=s0" alt="topApe" width="631" height="631"/>
        </a>
        <div className="OSImageOverlay"><a href="https://opensea.io/assets/0xbc4ca0eda7647a8ab7c2061c2e118a18a936f13d/3?ref=" title="Buy on OpenSea" target="_blank"><img src="https://storage.googleapis.com/opensea-static/Logomark/Badge%20-%20Available%20On%20-%20BW.png" alt="Available on OpenSea"/></a>
        </div></div>

</div>
<div className="TopGallery">
<div><img id="BABD" src="temp/0.png" alt="BABD" width="631" height="631"/></div>
<div><img id="BABD" src="temp/1.png" alt="BABD" width="631" height="631"/></div>
<div><img id="BABD" src="temp/2.png" alt="BABD" width="631" height="631"/></div>
<div><img id="BABD" src="temp/3.png" alt="BABD" width="631" height="631"/></div>
</div>

<div className="TopMint">
<a href="https://mint.boredapebelowdeck.com"><button className="mintbtn" type="button" >
                      BUY OCTOPI
                  </button></a>
</div>

<div className="SectionWelcome">
<h1>WELCOME</h1>
<h1>BELOW DECK</h1>
<div className='welcomesubline'>
                        <p>NOT AFFILIATED WITH BAYC ... <small>( However we do look</small> UP <small>to them )</small></p>
                  </div>
<p>BABD is an artwork project surfacing with 10,000 uniquely generated Octopi NFTs that will match their BAYC counterpart.</p>
<p> Destined to live in the depths of the Ethereum blockchain, these Octopi are rising from their murky waters to bring some more bizarre to your NFT world.</p>
<p>So get in and enjoy our underwater world filled with our Octopi ready to <i>occupi</i> the Bored Apes.</p>
<br></br>
<div className="tophighlight">
                          EVERY <b>BABD</b> NFT <u>MATCHES</u> A <b>BAYC</b> NFT
                  </div>

</div>
<img className="PipeDivider"  src="Pipedividinggraphic.jpg" alt="Pipes"/>

<div className="SectionSpecs">
<div><h1>THE SPECS</h1>
<p>
Each Below Deck NFT is uniquely generated from over <b>200</b> hand-drawn traits.</p> <p>  Some NFTs will be rarer than others.</p>

<p>Each BABD NFT will cleverly match its BAYC counterpart to create a bigger picture. </p>
<p> Each NFT will match number for number.</p> 
  <div className='welcomesubline'>
      <p>Eg:<small> BABD #8888 WILL MATCH BAYC #8888</small></p>
</div>


<p>The Octopi will be stored as tokens on the Ethereum blockchain.  Using a ERC721A based contract to help with gas optimization. </p> <p> Purchasing a BABD NFT in the public sale costs 0.08 ETH.</p>
</div>

<div className="SectionSpecsGallery">
  <img className="SectionSpecsGalleryBABD1" id="BABD" src="temp/0.png" alt="BABD" />
  <img className="SectionSpecsGalleryBABD2" id="BABD" src="temp/1.png" alt="BABD" />
  <img className="SectionSpecsGalleryBABD3" id="BABD" src="temp/2.png" alt="BABD" />
  <img className="SectionSpecsGalleryBABD4" id="BABD" src="temp/3.png" alt="BABD" />
  </div>
  <p></p>
  <p>Note: 200 Octopi will not be part of the sale. These will be used for giveaways, rewards and for the creators, family, and friends.</p>
</div>
<img className="PipeDivider2" src="Pipedivider2.jpg" alt="Pipes"/>
<h1>ANCHOR POINTS</h1>
<div className="SectionAnchorPoints">
    <div><img className="SectionAnchorGallery" id="BABD" src="lightning.jpg" alt="Lightning"/>
          <p>10,000 Uniquely generated BABD NFTs containing over 200 hand-drawn traits</p></div>
    <div><img className="SectionAnchorGallery" id="BABD" src="rainbow.jpg" alt="Rainbow"/>
          <p>Fair Launch & Fair Distribution</p></div>
    <div><img className="SectionAnchorGallery" id="BABD" src="trophey.jpg" alt="Trophey"/>
          <p>Ownership and commercial usage rights given to you.</p></div>
    <div><img className="SectionAnchorGallery" id="BABD" src="voodooicon.jpg" alt="Voodoo"/>
          <p>Holders gain additional benefits post mint sellout.</p></div>
</div>
<img className="PipeDivider" src="Pipedivider2.jpg" alt="Pipes"/>

<div className="SectionThree">




<div className="SectionSlimeGrid">
  <div className="col-6">
<h1>THE BIGGER PICTURE ( ROADMAP )</h1>
<div className='welcomesubline'>AFTER 100% SELL OUT, THE TREASURE CHEST WILL OPEN...</div>
<p>BABD is here to expand and reimagine what an NFT project can be. </p>
<p>The BABD series, just like our Octopi friends will consist of 8 tentacles, 8 matching pieces in total.</p>
<p>When you buy a BABD, you will have a significant piece to the much bigger picture.</p>


<div className='welcomesubline'>OCTOVIEWER</div>
 <p>The Octoviewer will be developed, displaying each and every BABD BAYC match.</p>
 <div className='welcomesubline'>VOODOO APE GIFT AIRDROP</div>
 <p>BABD holders receive an air dropped Voodoo Ape. Date TBA</p>
 <div className='welcomesubline'>SECOND INSTALLMENT</div>
 <p>Illustration and development of the second installment begins.</p>
 </div>
 <img className="col-5" src="slimegrid.jpg" alt="The Grid" width="764px" height="733"/>

</div>
<img className="PipeDivider2" src="Pipedivider2.jpg" alt="Pipes"/>

<div className="SectionVoodoo">
  <div className="col-6">
<h1>VOODOO APE</h1>
<p> The Voodoo Ape is our Air Drop gift to you.</p>
<p>Each BABD holder will receive a Voodoo Ape NFT with matching traits
to your BABD. </p>
<p>Air Drop Date TBA</p>
 </div>
<img className="col-5" src="voodoologo.jpg" alt="VoodooLogo"/>


</div>
<img className="PipeDivider" src="Pipedividinggraphic.jpg" alt="Pipes"/>
<div className="SectionFAQ">
<Faq
                data={{title: "FAQ",
                rows: [
                    {
                        title: "How many BABD's will there be?",
                        content: 
                        <div><p>A total of 10,000 BABD's will be part of the collection.</p> <p>Exactly 1 BABD NFT has been matched to each BAYC NFT.</p></div>,
                    },
                    {
                        title: "How many traits are there?",
                        content:
                        <p>There is a combination of approximately 200+ original hand-drawn traits across the collection.</p>,
                    },
                    {
                      title: "So ... How did you match every BABD to a BAYC?",
                      content: <div><p>Not Telling</p></div>,
                    },
                    {
                      title: "Was it a lot of hard work?",
                      content: <div><p>Yes</p></div>,
                    },
                    {
                        title: "Is BABD affiliated with BAYC?",
                        content: <p>No</p>,
                    },
                  {
                    title: "How much are BABD NFT's?",
                    content: <p>During the public mint BABD NFT's will be 0.08 ETH each</p>,
                },
                  {
                    title: "How do I buy a Bored Ape Below Deck NFT?",
                    content: <div><p>Download Metamask, have Ethereum in your Metamask wallet, and wait for the Mint date/time. </p> <p>If on mobile, you will need to use Metamask browser.</p></div>,
                },
                ],}}
                styles={{ bgColor: 'black',
                  titleTextColor: "white",
                  rowTitleColor: "yellow",
                  rowTitleTextSize: "1rem",
                  rowContentColor: 'white',
                  rowContentTextSize: "1rem",
                  arrowColor: "red",
            }}
                config={{// animate: true,
                  // arrowIcon: "V",
                  // tabFocus: true
            }}
            />



</div>

<img className="PipeDivider" src="Pipedividinggraphic.jpg" alt="Pipes"/>

</div>
<div className="SectionLast">
  
<video
        autoPlay muted loop playsInline id="FooterVid" width="1140" height="812"
        ref={videoRef}
        onCanPlay={() => setPlayBack()}>
          
        <source src='FooterVid.mp4' type="video/mp4"  />
      </video>
      <img className="PipeDivider" src="babdtoppipegraphic.jpg" alt="Pipes"/>
    <img src="SectionLastBackground.jpg" alt="Going Far Below"/>
    <div className="WLFish">
    <img
      src="FISHdark.png"
      alt="Angry Angler Fish"
      onMouseOver={e => (e.currentTarget.src = "FISHlit.png")}
      onMouseOut={e => (e.currentTarget.src = "FISHdark.png")}
      onTouchStart={e => (e.currentTarget.src = "FISHlit.png")}
      onTouchEnd={e => (e.currentTarget.src = "FISHdark.png")}
      
  />
    </div>

</div>
<div className="connecticonsplacefooter">
<a href="https://etherscan.io/address/0xbA984C5D209F4b337ead2DA2fa7be946C20dd065" className="connecticons">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 293.775 293.667">
  <g id="etherscan-logo-light-circle" transform="translate(-219.378 -213.333)">
    <path id="Path_1" data-name="Path 1" d="M280.433,353.152A12.45,12.45,0,0,1,292.941,340.7l20.737.068a12.467,12.467,0,0,1,12.467,12.467v78.414c2.336-.692,5.332-1.43,8.614-2.2a10.389,10.389,0,0,0,8.009-10.11V322.073a12.469,12.469,0,0,1,12.467-12.47h20.779a12.47,12.47,0,0,1,12.467,12.47v90.276s5.2-2.106,10.269-4.245a10.408,10.408,0,0,0,6.353-9.577V290.9a12.466,12.466,0,0,1,12.465-12.467h20.779A12.468,12.468,0,0,1,450.815,290.9v88.625c18.014-13.055,36.271-28.758,50.759-47.639a20.926,20.926,0,0,0,3.185-19.537,146.6,146.6,0,0,0-136.644-99.006c-81.439-1.094-148.744,65.385-148.736,146.834a146.371,146.371,0,0,0,19.5,73.45,18.56,18.56,0,0,0,17.707,9.173c3.931-.346,8.825-.835,14.643-1.518a10.383,10.383,0,0,0,9.209-10.306V353.152" transform="translate(0 0)" fill="#fff"/>
    <path id="Path_2" data-name="Path 2" d="M244.417,398.641A146.808,146.808,0,0,0,477.589,279.9c0-3.381-.157-6.724-.383-10.049-53.642,80-152.686,117.405-232.79,128.793" transform="translate(35.564 80.269)" fill="#bfcfda"/>
  </g>
</svg>
        </a>
    <a href="https://opensea.io/collection/boredapebelowdeck" className="connecticons">
        <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><title>OpenSea</title><path d="M12 0C5.374 0 0 5.374 0 12s5.374 12 12 12 12-5.374 12-12S18.629 0 12 0ZM5.92 12.403l.051-.081 3.123-4.884a.107.107 0 0 1 .187.014c.52 1.169.972 2.623.76 3.528-.088.372-.335.876-.614 1.342a2.405 2.405 0 0 1-.117.199.106.106 0 0 1-.09.045H6.013a.106.106 0 0 1-.091-.163zm13.914 1.68a.109.109 0 0 1-.065.101c-.243.103-1.07.485-1.414.962-.878 1.222-1.548 2.97-3.048 2.97H9.053a4.019 4.019 0 0 1-4.013-4.028v-.072c0-.058.048-.106.108-.106h3.485c.07 0 .12.063.115.132-.026.226.017.459.125.67.206.42.636.682 1.099.682h1.726v-1.347H9.99a.11.11 0 0 1-.089-.173l.063-.09c.16-.231.391-.586.621-.992.156-.274.308-.566.43-.86.024-.052.043-.107.065-.16.033-.094.067-.182.091-.269a4.57 4.57 0 0 0 .065-.223c.057-.25.081-.514.081-.787 0-.108-.004-.221-.014-.327-.005-.117-.02-.235-.034-.352a3.415 3.415 0 0 0-.048-.312 6.494 6.494 0 0 0-.098-.468l-.014-.06c-.03-.108-.056-.21-.09-.317a11.824 11.824 0 0 0-.328-.972 5.212 5.212 0 0 0-.142-.355c-.072-.178-.146-.339-.213-.49a3.564 3.564 0 0 1-.094-.197 4.658 4.658 0 0 0-.103-.213c-.024-.053-.053-.104-.072-.152l-.211-.388c-.029-.053.019-.118.077-.101l1.32.357h.01l.173.05.192.054.07.019v-.783c0-.379.302-.686.679-.686a.66.66 0 0 1 .477.202.69.69 0 0 1 .2.484V6.65l.141.039c.01.005.022.01.031.017.034.024.084.062.147.11.05.038.103.086.165.137a10.351 10.351 0 0 1 .574.504c.214.199.454.432.684.691.065.074.127.146.192.226.062.079.132.156.19.232.079.104.16.212.235.324.033.053.074.108.105.161.096.142.178.288.257.435.034.067.067.141.096.213.089.197.159.396.202.598a.65.65 0 0 1 .029.132v.01c.014.057.019.12.024.184a2.057 2.057 0 0 1-.106.874c-.031.084-.06.17-.098.254-.075.17-.161.343-.264.502-.034.06-.075.122-.113.182-.043.063-.089.123-.127.18a3.89 3.89 0 0 1-.173.221c-.053.072-.106.144-.166.209-.081.098-.16.19-.245.278-.048.058-.1.118-.156.17-.052.06-.108.113-.156.161-.084.084-.15.147-.208.202l-.137.122a.102.102 0 0 1-.072.03h-1.051v1.346h1.322c.295 0 .576-.104.804-.298.077-.067.415-.36.816-.802a.094.094 0 0 1 .05-.03l3.65-1.057a.108.108 0 0 1 .138.103z" fill='white'/></svg>
        </a>
        <a href="https://twitter.com/BoredApeBD" className="connecticons">
        <svg className="fill-current h-8 w-8 mr-2" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><title>Twitter</title><path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" fill='white'/></svg>
        </a>
    </div>

    <div className="cnotice">
      <p>&copy; 2022 Bored Ape Below Deck</p>
    </div>

    <div className="ImgPreLoad">
      <img src="FISHlit.png"  alt=""   height="1" width="1"/>
    </div>
  </div>
    
  );
}


export default Home;
